module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAsElEQVRYR+3YwQkCMRAF0D8Bq/Kwdy+2kwI8DKnG29ZgSwvxi4IgghL4Crvwc84MyQszIQn8YGTmEcD5LdWh1jqr6UNNcI/3AlVFC1pQEHAVC3iPUAtacETAjXpE6dscC65asLU29d6lflhK2ZM8vW6UZAVwUTYfEdfIzAXATkn0r1iSixeo6G5DcPVFohzBM9aNWlW0oAUFAekOdhX7Vef/wcHqc6MehPo4zYIWFARu0C3gDZO1UEEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/add_address_1.png
// module id = pdfc
// module chunks = 1